import { z } from 'zod'
import { WhiteTooltip } from '../../../../constants/prepare.jsx'

export const columns = [
  { id: 'ruleName', label: 'Rule name', minWidth: 100 },

  {
    id: 'ruleStatus',
    label: 'Status',
    width: '150px',
    align: 'center',
    render: (value, row) => {
      const getStatusColor = status => {
        switch (status?.toUpperCase()) {
          case "ACTIVE":
            return { backgroundColor: '#F0FDF3', color: '#197C37' }
          default:
            return { backgroundColor: '#E2E3E5', color: '#495057' }
        }
      }


      const { backgroundColor, color } = getStatusColor(value)

      const badge = (
        <span
          style={{
            backgroundColor,
            color,
            padding: '2px 6px',
            borderRadius: 4,
            display: 'inline-block',
            cursor: 'pointer',
          }}
        >
          {value || 'N/A'}
        </span>
      )

      return (
        <WhiteTooltip placement="top" title={row?.statusMessage || ''} arrow>
          <span>{badge}</span>
        </WhiteTooltip>
      )

      return badge
    },
  },
  { id: 'parameter_1', label: 'Parameter1', minWidth: 100 },
  { id: 'parameter_2', label: 'Parameter2', minWidth: 100 },
  { id: 'parameter_3', label: 'Parameter3', minWidth: 100 },
  { id: 'parameter_4', label: 'Parameter4', minWidth: 100 },
  { id: 'parameter_5', label: 'Parameter5', minWidth: 100 },
  { id: 'parameter_6', label: 'Parameter6', minWidth: 100 },
  { id: 'parameter_7', label: 'Parameter7', minWidth: 100 },
  { id: 'parameter_8', label: 'Parameter8', minWidth: 100 },
  { id: 'createdBy', label: 'Created by', minWidth: 150 },
  { id: 'createdDate', label: 'Created at', minWidth: 150 },
  { id: 'lastModifiedBy', label: 'Updated by', minWidth: 150 },
  { id: 'lastModifiedDate', label: 'Updated at', minWidth: 150 },
]

// Validation for yyyymmdd date format
const ddMMyyyyListZod = z
  .string()
  .regex(
    /^((0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/\d{4}(\s*,\s*(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/\d{4})*)?$/,
    'Invalid Input. Example: 29/08/2025, 01/09/2025'
  )
export const searchFields = [
  ...columns.map(col => {
    if (col.id === 'createdDate' || col.id === 'lastModifiedDate') {
      return {
        ...col,
        type: 'text',
        placeholder: `Example: 25/08/2025 (dd/mm/yyyy)`,
        zod: ddMMyyyyListZod,
      }
    }
    return {
      ...col,
      type: col.type || 'text',
      placeholder: `Enter ${col.label}`,
    }
  }),
]
